<!-- <button mat-icon-button class="close-button" [mat-dialog-close]="true">
<mat-icon class="close-icon" color="warn">close</mat-icon>
</button> -->
<h1 mat-dialog-title>Acción realizada :: <strong>Modificar</strong></h1>
<div mat-dialog-content cdkTrapFocus>
    <app-crear-rol></app-crear-rol>
</div>
